'use strict';

const Enum = require('./enum');

module.exports.ManufacturingShipmentStatuses = Object.create(Enum, {
  UPLOADING: { value: 'uploading', enumerable: true },
  UPLOADED: { value: 'uploaded', enumerable: true },
  DOWNLOAD_SUCCESS: { value: 'download_success', enumerable: true },
  DOWNLOAD_FAILURE: { value: 'download_failure', enumerable: true },
  DECRYPT_SUCCESS: { value: 'decrypt_success', enumerable: true },
  DECRYPT_FAILURE: { value: 'decrypt_failure', enumerable: true },
  IMPORT_SUCCESS: { value: 'import_success', enumerable: true },
  IMPORT_FAILURE: { value: 'import_failure', enumerable: true },
  FAILED: { value: 'failed', enumerable: true },
});

module.exports.ManufacturingImportFailureCodes = Object.create(Enum, {
  MALFORMED_DATA: { value: 'malformed_data', enumerable: true },
  DUPLICATE_DEVICE: { value: 'duplicate_device', enumerable: true },
  MISSING_DEVICE: { value: 'missing_device', enumerable: true },
});

module.exports.ManufacturingTriggers = Object.create(Enum, {
  FILE_UPLOADED: { value: 'FILE.UPLOADED', enumerable: true },
});
